import { render } from "./PollRewards.vue?vue&type=template&id=1b641c43"
import script from "./PollRewards.vue?vue&type=script&lang=js"
export * from "./PollRewards.vue?vue&type=script&lang=js"

import "./PollRewards.vue?vue&type=style&index=0&id=1b641c43&lang=css"

import exportComponent from "C:\\wamp64\\www\\wordpress\\wp-content\\themes\\yka-theme-2022\\vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__